import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  sessionList: { sessions: [] },
  sessionTrialList: { sessionsTrial: [] },

  sessionsLoading: false,

  // TrialStartDate:null,
  // TrialExpiryDate:null,
  
  rewardsDetails:null,


  userDetails: {
    "Plan Name": null,
    "Total Sessions": null,
    "Expiry Date": null,
    Amount: null,
    Taxes: null,
    ogTotal: null,
    ogTaxes: null,
    "Total Amount": null,
    startdate: null,
    planid: null,
    sessionid: null,
    taxpercent: null,
    false_cost: null,
    couponcost: null,
    couponcode: null,
    couponid: null,
    userid: null,
    name: null,
    branchid: null,
    daystime: null,
    orderid: null,
    transactionid: null,
    transactionuid: null,
    email: null,
    phone: null,
    firstname: null,
    isTrial:null,

  },
  planName: null,

  startDateParam: null
 
};

const UrlSlice = createSlice({
  name: "UrlData",
  initialState: initialState,
  reducers: {
    sessionRed: (state, action) => {
      const next = action.payload || [];
      const prev = state.sessionList.sessions || [];
      if (prev === next) return;
      if (Array.isArray(prev) && Array.isArray(next) && prev.length === next.length) {
        let same = true;
        for (let i = 0; i < prev.length; i++) {
          const a = prev[i], b = next[i];
          if (
            a?.sessionid !== b?.sessionid ||
            a?.name !== b?.name ||
            a?.sumcost !== b?.sumcost ||
            a?.daystime !== b?.daystime
          ) { same = false; break; }
        }
        if (same) return;
      }
      state.sessionList.sessions = next;
    },

    userDetailAction: (state, action) => {
      const u = state.userDetails;
      const p = action.payload || {};
      if (u.startdate !== p.startdate) u.startdate = p.startdate;
      if (u["Plan Name"] !== p.planname) u["Plan Name"] = p.planname;
      if (u.planid !== p.planid) u.planid = p.planid;
      if (u.sessionid !== p.sessionid) u.sessionid = p.sessionid;
      if (u.Amount !== p.basecost) u.Amount = p.basecost;
      if (u["Total Amount"] !== p.sumcost) u["Total Amount"] = p.sumcost;
      if (u.ogTaxes !== p.ogTaxes) u.ogTaxes = p.ogTaxes;
      if (u.ogTotal !== p.ogTotal) u.ogTotal = p.ogTotal;
      if (u.taxpercent !== p.taxpercent) u.taxpercent = p.taxpercent;
      if (u.false_cost !== p.false_cost) u.false_cost = p.false_cost;
      if (u.Taxes !== p.taxcost) u.Taxes = p.taxcost;
      if (u.name !== p.name) u.name = p.name;
      if (u["Expiry Date"] !== p.expirydate) u["Expiry Date"] = p.expirydate;
      if (u["Total Sessions"] !== p.max_sessions) u["Total Sessions"] = p.max_sessions;
      if (u.branchid !== p.branchid) u.branchid = p.branchid;
      if (u.daystime !== p.daystime) u.daystime = p.daystime;
      if (u.isTrial !== p.isTrial) u.isTrial = p.isTrial;
    },

    couponDetailAction: (state, action) => {      
      const u = state.userDetails; const p = action.payload || {};
      if (u.couponcost !== p.couponcost) u.couponcost = p.couponcost;
      if (u.couponcode !== p.couponcode) u.couponcode = p.couponcode;
      if (u.couponid !== p.couponid) u.couponid = p.couponid;
      if (u.Discount !== p.Discount) u.Discount = p.Discount;      
      if (u.Taxes !== p.Taxes) u.Taxes = p.Taxes;
      if (u.ogTaxes !== p.ogTaxes) u.ogTaxes = p.ogTaxes;
      if (u.ogTotal !== p.ogTotal) u.ogTotal = p.ogTotal;
      if (u["Total Amount"] !== p.total) u["Total Amount"] = p.total;
    },

    coinsDetailAction: (state, action) => {
      const u = state.userDetails; const p = action.payload || {};
      if (u.Taxes !== p.Taxes) u.Taxes = p.Taxes;
      if (u.ogTaxes !== p.ogTaxes) u.ogTaxes = p.ogTaxes;
      if (u.ogTotal !== p.ogTotal) u.ogTotal = p.ogTotal;
      if (u["Total Amount"] !== p.total) u["Total Amount"] = p.total;
    },

    restCouponDetailAction: (state, action) => {
      const u = state.userDetails;
      if (u.couponcost != null) u.couponcost = null;
      if (u.couponcode != null) u.couponcode = null;
      if (u.couponid != null) u.couponid = null;
      if (u.Discount != null) u.Discount = null;      
      if (u.Taxes != null) u.Taxes = null;
      if (u["Total Amount"] != null) u["Total Amount"] = null;
    },

    rewardsDataAction:(state, action)=>{
      if (state.rewardsDetails === action.payload) return;
      state.rewardsDetails = action.payload;
    },
    
    PlanNameAction: (state, action) => {
      if (state.planName === action.payload) return;
      state.planName = action.payload;
    },
    FormPageAction: (state, action) => {
      const u = state.userDetails; const p = action.payload || {};
      if (u.email !== p.email) u.email = p.email;
      if (u.phone !== p.phone) u.phone = p.phone;
    },

    FormPageContactAction: (state, action) => {  
      if (state.userDetails.phone === action.payload) return;
      state.userDetails.phone = action.payload;
    },

    TransactionAction: (state, action) => {
      const u = state.userDetails; const p = action.payload || {};
      if (u.orderid !== p.orderid) u.orderid = p.orderid;
      if (u.transactionid !== p.transactionid) u.transactionid = p.transactionid;
      if (u.transactionuid !== p.transactionuid) u.transactionuid = p.transactionuid;
    },

    UseridAction: (state, action) => {
      const u = state.userDetails; const p = action.payload || {};
      if (u.firstname !== p.firstname) u.firstname = p.firstname;
      if (u.userid !== p.userid) u.userid = p.userid;
    },
    resetState(state, action) {
      return initialState;
    },

    sessionTrial: (state, action) => {
      const next = action.payload || [];
      const prev = state.sessionTrialList.sessionsTrial || [];
      if (prev === next) return;
      if (Array.isArray(prev) && Array.isArray(next) && prev.length === next.length) {
        let same = true;
        for (let i = 0; i < prev.length; i++) {
          const a = prev[i], b = next[i];
          if (
            a?.sessionid !== b?.sessionid ||
            a?.name !== b?.name ||
            a?.sumcost !== b?.sumcost ||
            a?.daystime !== b?.daystime
          ) { same = false; break; }
        }
        if (same) return;
      }
      state.sessionTrialList.sessionsTrial = next;

    },

    starDateAction: (state, action) => {
      if (state.userDetails.startdate === action.payload) return;
      state.userDetails.startdate = action.payload;

    },

    endDateAction: (state, action) => {
      if (state.userDetails["Expiry Date"] === action.payload) return;
      state.userDetails["Expiry Date"] = action.payload;
    },

    setSessionsLoading: (state, action) => {
      if (state.sessionsLoading === action.payload) return;
      state.sessionsLoading = action.payload;
    },

    setStartDateParam: (state, action) => {
      if (state.startDateParam === action.payload) return;
      state.startDateParam = action.payload;
    },



    // TrialDateAction:(state,action)=>{
    //   state.TrialStartDate = action.payload;
    //   // state.TrialStartDate["Expiry Date"] = action.payload;


    // }

  },
});

export const {
  sessionRed,
  userDetailAction,
  PlanNameAction,
  FormPageAction,
  TransactionAction,
  FormPageContactAction,
  UseridAction,
  sessionTrial,
  TrialDateAction,
  couponDetailAction,
  coinsDetailAction,
  rewardsDataAction,
  resetState,
  starDateAction,
  setSessionsLoading,
  setStartDateParam,
  restCouponDetailAction,
  endDateAction
} = UrlSlice.actions;
// export const resetState = () => ({
//   type: "mySlice/resetState",
// });
export const SweatReducer = UrlSlice.reducer;
